import React from "react";
import badges from "../../../_helpers/badgeHelper";
import helpers from "../../../_helpers/common";
import { hasAuthorization } from "../../../_helpers/hasAuthorization";
import { TooltipWrapper } from "../../common";
import { NewsLetterEmail } from "../../../types/interfaces";

type ListDataProps = {
  isLoading: boolean;
  results: NewsLetterEmail[] | null;
  getListData: () => void;
  changeEmailStatus: (itemid?: string, status?: number) => void;
  deleteEmail: (itemid?: string) => void;
};

const ListData: React.FC<ListDataProps> = (props) => {
  const { isLoading, results, getListData, changeEmailStatus, deleteEmail } =
    props || {};

  return (
    <table
      className="table table-hover table-row-bordered table-row-solid gy-4 align-middle fw-bold w-100"
    >
      <thead
        style={{
          position: "sticky",
          top: 0,
          zIndex: 5,
          backgroundColor: `${isLoading ? "#BBBCBE" : "white"}`,
          boxShadow: "0 4px 2px -2px rgba(190, 190, 190, 0.2)",
        }}
      >
        <tr className="text-start text-gray-800 fw-bold fs-7 text-uppercase gs-0">
          {/* <th
            className="w-10px pe-2 dt-orderable-none"
            data-dt-column="0"
            rowSpan={1}
            colSpan={1}
            aria-label=""
          >
            <span className="dt-column-title">
              <div className="form-check form-check-sm form-check-custom form-check-solid me-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  data-kt-check="true"
                  data-kt-check-target="#kt_ecommerce_products_table .form-check-input"
                  value="1"
                />
              </div>
            </span>
            <span className="dt-column-order"></span>
          </th> */}
          <th className="min-w-250px">Email</th>
          <th className="min-w-200px">Is Verified</th>
          <th className="min-w-70px">Status</th>
          <th className="min-w-100px">Created Date</th>
          <th className="min-w-70px">Actions</th>
        </tr>
      </thead>
      <tbody className="fw-semibold text-gray-600">
        {!results || results.length === 0 ? (
          <tr className="text-center">
            <td colSpan={5}>No Content Found</td>
          </tr>
        ) : (
          results.map((item) => (
            <tr key={item._id}>
              {/* <td>
                <div className="form-check form-check-sm form-check-custom form-check-solid">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    value={item._id}
                  />
                </div>
              </td> */}
              <td>{item.email || "N/A"}</td>
			  <td>
                {badges.eventStatusBadge(
                  item.is_verified ?? 0,
                  item?.verifiedname ?? ""
                )}
              </td>
              <td>
                {badges.eventStatusBadge(
                  item.status ?? 0,
                  item?.statusname ?? ""
                )}
              </td>
              <td>
                {helpers.convertDateTime(
                  item?.created_at,
                  "DD MMM YYYY - HH:mm A"
                ) || "N/A"}
              </td>
              <td className="">
                <div className="d-flex">
                  {hasAuthorization("update_status", "newsletter-email") && (
                    <TooltipWrapper title="Update Verification Status" placement="top">
                      <span
                        className="btn btn-sm btn-icon btn-light btn-active-light-warning me-2"
                        onClick={() =>
                          changeEmailStatus(item?._id, item?.is_verified)
                        }
                      >
                        <i className="ki-outline ki-shield-tick text-warning fs-2"></i>
                      </span>
                    </TooltipWrapper>
                  )}

                  {hasAuthorization("delete", "newsletter-email") && (
                    <TooltipWrapper title="Delete" placement="top">
                      <span
                        className="btn btn-sm btn-icon btn-light btn-active-light-danger"
                        onClick={() => deleteEmail(item?._id)}
                      >
                        <i className="ki-outline ki-trash text-danger fs-2"></i>
                      </span>
                    </TooltipWrapper>
                  )}
                </div>
              </td>
            </tr>
          ))
        )}
      </tbody>
      <tfoot></tfoot>
    </table>
  );
};

export default ListData;
